import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class VersionCheckService {
    // version.json is generated by build/post-build.js after every build and written to
    // dist/microhd/browser/version.json. It does NOT exist during local dev (ng serve), which
    // is why 404s are silently ignored in the error handler below.
    // To generate it manually: npm run build && npm run post-build
    private currentversion: string | null = null;

    constructor(
        private http: HttpClient,
        @Inject(PLATFORM_ID) private platformId: object,
    ) {
        if (isPlatformBrowser(this.platformId)) {
            this.currentversion = window.localStorage.getItem('version');
        }
    }

    public initVersionCheck(url: string, frequency = 1000 * 60 * 30) {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        setInterval(() => {
            this.checkVersion(url);
        }, frequency);
        this.checkVersion(url);
    }

    private checkVersion(url: string) {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        this.http.get(url + '?t=' + new Date().getTime())
            .subscribe(
                (response: any) => {
                    const version = response.version;
                    window.localStorage.setItem('version', version);
                    if (this.currentversion) {
                        if (this.currentversion == response.version) {
                            return false;
                        } else {
                            window.location.reload();
                            window.location.href = window.location.href;
                        }
                    } else {
                        window.location.reload();
                        window.location.href = window.location.href;
                    }
                },
                (err: HttpErrorResponse) => {
                    if (err.status !== 404) {
                        console.warn('Version check failed:', err.message);
                    }
                }
            );
    }
}
